import React, { useContext } from 'react';
import Consent from './consent.js';
import LegitimateInterest from './legitimate-interest.js';
import FinnLogo from '../icons/finn-logo.js';
import { Box } from '@warp-ds/react';
import { Trans, useLingui } from '@lingui/react';
import TranslationContext from '../translation-context.js';

export type ConsentsProps = {
    consentUser: ConsentUser;
    givenConsents: GivenConsents;
    hmacToken: string;
    baseUrl: string;
    children?: React.ReactNode;
};

function Section({
    children,
}: {
    children: React.ReactNode;
}): React.ReactElement {
    return (
        <Box bleed className="s-bg-default mt-16 mb-16">
            <div>{children}</div>
        </Box>
    );
}

export default function Consents(props: ConsentsProps): React.ReactElement {
    const { texts } = useContext(TranslationContext);
    return (
        <div className="md:grid grid-cols-3 gap-16 space-y-16 md:space-y-0 mb-32">
            <div className="md:col-span-2">
                <div className="flex">
                    <div className="grow">
                        <h2 className="text-l">
                            <Trans
                                id="privacy-settings.consent.header"
                                values={texts}
                            />
                        </h2>
                        <p>
                            <Trans
                                id="privacy-settings.consent.paragraph"
                                values={texts}
                            />
                        </p>
                    </div>
                    <div>
                        <FinnLogo width={80} height={28} />
                    </div>
                </div>
                <div>
                    {props.givenConsents.consents.map((consent, index) => (
                        <Section key={consent.userConsent.name}>
                            <Consent givenConsent={consent} />
                        </Section>
                    ))}
                    {props.givenConsents.legitimateInterests.map(
                        (legitimateInterest, index) => (
                            <Section key={legitimateInterest.purpose.name}>
                                <LegitimateInterest
                                    givenLegitimateInterest={legitimateInterest}
                                />
                            </Section>
                        ),
                    )}
                    {props.consentUser.isLoggedIn && <>{props.children}</>}
                </div>
            </div>
        </div>
    );
}
